import React from "react";
import { Menu } from "antd";
import { Link } from "react-router-dom";
import { WEBSITE_URL } from "../../Helper";

const Index = () => {
  const siteUrl = WEBSITE_URL.replace('https:', '');

  return (
    <div className="drawerMenu">
      <Menu mode="inline" className="mobileMenu">
        <Menu.Item key="1">
          <span>Home</span>
          <Link to={`${siteUrl}/`}></Link>
        </Menu.Item>
        <Menu.Item key="2">
          <span>Memberships</span>
          <Link to={`${siteUrl}/subscribe/`}></Link>
        </Menu.Item>
        <Menu.Item key="3" style={{ position: 'relative' }}>
          <span className="new-ribbon-badge">NEW</span>
          <span>Claims & Conditions</span>
          <Link to={`${siteUrl}/defects/`}></Link>
        </Menu.Item>
        <Menu.Item key="4">
          <span>Find A Inspector</span>
          <Link to={`${siteUrl}/locator/`}></Link>
        </Menu.Item>
        <Menu.Item key="5">
          <span>About Us</span>
          <Link to={`${siteUrl}/about-us/`}></Link>
        </Menu.Item>
        <Menu.Item key="6">
          <span>Accounts</span>
          <Link to={`${siteUrl}/membership-account/`}></Link>
        </Menu.Item>
      </Menu>
    </div>
  );
};

export default Index;
